<template>
  <div class="text-input">
    <input
      :type="inputType"
      :value="displayValue"
      @input="handleInput"
      @keydown="handleKeyDown"
      :placeholder="placeholder"
      ref="input"
    >
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      internalValue: '',
      prefix: '010-'
    }
  },
  computed: {
    displayValue() {
      if (this.inputType === 'tel') {
        const numbers = this.internalValue;
        if (numbers.length <= 3) {
          return this.prefix;
        } else if (numbers.length <= 7) {
          return this.prefix + numbers.slice(3);
        } else {
          return this.prefix + numbers.slice(3, 7) + '-' + numbers.slice(7);
        }
      }
      return this.internalValue;
    }
  },
  methods: {
    handleInput(event) {
      if (this.inputType === 'tel') {
        let inputValue = event.target.value.replace(/\D/g, '');
        
        if (inputValue.length < 3) {
          inputValue = '010';
        } else if (inputValue.length > 11) {
          inputValue = inputValue.slice(0, 11);
        }

        this.internalValue = inputValue;
        this.$emit('input', this.displayValue);
        
        this.$nextTick(() => {
          const cursorPosition = this.getCursorPosition(inputValue);
          this.$refs.input.setSelectionRange(cursorPosition, cursorPosition);
        });
      } else {
        this.internalValue = event.target.value;
        this.$emit('input', this.internalValue);
      }
    },
    handleKeyDown(event) {
      if (this.inputType === 'tel') {
        const cursorPosition = event.target.selectionStart;
        const currentValue = this.internalValue;

        // 숫자 키, 백스페이스, 삭제, 방향키만 허용
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
          event.preventDefault();
          return;
        }

        // '010-' 영역에서의 백스페이스와 삭제 방지
        if ((event.key === 'Backspace' && cursorPosition <= 4) ||
            (event.key === 'Delete' && cursorPosition < 4)) {
          event.preventDefault();
          return;
        }

        // 11자리 이후 입력 방지
        if (/^\d$/.test(event.key) && currentValue.length >= 11) {
          event.preventDefault();
        }
      }
    },
    getCursorPosition(inputValue) {
      if (this.inputType !== 'tel') return inputValue.length;
      
      if (inputValue.length <= 3) {
        return 4; // '010-' 다음 위치
      } else if (inputValue.length <= 7) {
        return inputValue.length + 1; // +1 for the first hyphen
      } else {
        return inputValue.length + 2; // +2 for two hyphens
      }
    }
  },
  created() {
    if (this.inputType === 'tel') {
      this.internalValue = this.value.replace(/\D/g, '');
      if (this.internalValue.length < 3) {
        this.internalValue = '010';
      }
      this.$emit('input', this.displayValue);
    } else {
      this.internalValue = this.value;
    }
  },
  watch: {
    value(newValue) {
      if (this.inputType === 'tel') {
        const numericValue = newValue.replace(/\D/g, '');
        if (numericValue !== this.internalValue) {
          this.internalValue = numericValue.startsWith('010') ? numericValue : '010' + numericValue.slice(3);
          if (this.internalValue.length > 11) {
            this.internalValue = this.internalValue.slice(0, 11);
          }
          this.$emit('input', this.displayValue);
        }
      } else {
        this.internalValue = newValue;
      }
    }
  }
}
</script>

<style scoped>
.text-input input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>